<div class="modal-header">
    <div class="modelHeading">
      <h6 class="modalTitle">Notification details</h6>
    </div>
    <button type="button" class="btnClose" (click)="onClose();"></button>
</div>
<div class="modal-body">
    <div class="userDetailsInfo row">
        <div class="col-12 col-sm-8 col-md-8">
          <div class="labelBox pt-4 pb-4">
            <label>Title</label>
            <p>{{notificationData?.title || "--"}}</p>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md-4">
            <div class="labelBox pt-4 pb-4">
              <label>Published On</label>
              <p>{{notificationData?.createdAt | date: "dd MMM yyyy"}} | {{notificationData?.createdAt | date: "hh:mm a"}}</p>
            </div>
          </div>
    </div>
    <div class="userDetailsInfo row">
        <div class="col-12 col-sm-12 col-md-12">
          <div class="labelBox pt-4 pb-4">
            <label>Message</label>
            <p>{{notificationData?.message || "--"}}</p>
          </div>
        </div>
    </div>
</div>